export default {
  app: {
    title: 'Mesa de Regalos',
    subtitle: 'Mesa de Regalos',
    description: 'Mesa de Regalos',
    head: {
      titleTemplate: 'Mesa de Regalos',
      meta: [
        { name: 'description', content: 'La Mesa de Regalos se renueva para ti, nuevos beneficios y herramientas para el evento de tus sueños.' },
        { charset: 'utf-8' },
        { property: 'og:site_name', content: 'Mesa de Regalos' },
        { property: 'og:image', content: 'https://assets.liverpool.com.mx/assets/images/share/liverpool_share_list.png' },
        { property: 'og:locale', content: 'es_MX' },
        { property: 'og:title', content: 'Mesa de Regalos' },
        { property: 'og:description', content: 'Mesa de Regalos' },
        { property: 'og:card', content: 'summary' },
        { property: 'og:site', content: 'Mesa de Regalos' },
        { property: 'og:creator', content: 'Liverpool' },
        { property: 'og:image:width', content: '200' },
        { property: 'og:image:height', content: '200' },
      ],
    },
  },
};
